var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account",class:{ visible: _vm.isVisible },on:{"click":_vm.onAccountClick}},[_c('div',{staticClass:"account-icon"}),_c('div',{staticClass:"account-name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }